<template>
   
   <div class="column center" style="margin-bottom: 12px;">
        <h1 class="upper ups" style="white-space: nowrap;">{{ title }}</h1>
        <p v-if="desc" class="sub">{{ desc }}</p>   
   </div>
   
</template>
<script>

/*

    <PageTitle title="Jobs" desc="Something"/>
 
*/

export default {
    data: function () {return {}},
    props:{
        title: String,
        desc: String,        
    },    
}
</script>

<style scoped>
.sub { 
    letter-spacing: 5%;     
    font-size: 9px; 
    font-weight: 500; 
    text-transform: uppercase; 
    color: var(--g4); 
    line-height: 14px; 
    margin: 0 0 6px; 
}

.ups { 
    letter-spacing: 5%;
}
</style>

